import english from './en';
import french from './fr';

const languages = {
	en: english,
	fr: french,
};

export const language = (lang) => languages[lang];

export default languages;
